<template>
  <div :class="[$style.guideRemind]">
    <img :src="`${$cdnLink}/charge/close.png`" alt="" :class="$style.close" @click="$emit('close')" />
    <p><b>您的礼包码为<span>{{code}}</span>，请及时兑换</b></p>
    <p style="margin-bottom: 15px"><b>避免礼包码逾期时效，无法兑换。</b></p>
    <p>您可点击下方“复制礼包码”按钮，复制礼包码，然后前往游戏中的礼包兑换入口，输入礼包码后即可获得礼包。</p>
    <p>如有任何问题，请<span>联系客服</span></p>
    <div :class="$style.btnGroup">
      <button :class="`copy-btn`" :data-clipboard-text="code">复制礼包码</button>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { mapState } from 'vuex';
import { gameOpenDownloads } from '@/bridge/AppJsBridge';
import { buryReportV2 } from "@/libs/business/account"

export default {
  name: '',
  props: ['code'],
  data() {
    return {
    };
  },
  mounted() {
    const userName = this.$getStorage('username');
    this.userName = userName;
    this.copyInit();
  },
  methods: {
    redirectWechat() {
      gameOpenDownloads({
        gameUrl: this.guideRemindInfo.pop_value,
      });
    },
    copyInit() {
      this.copy = new Clipboard('.copy-btn');
      this.copy.on('success', (e) => {
        buryReportV2('SDK_AUTO_GIFT_CODE_COPY', '')
        this.$toast('复制成功');
      });
    },
  },
};
</script>

<style lang="scss" module>
.guideRemind {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 342px;
    height: 260px;
    margin: auto;
    padding: 50px 40px 0;
    background: url('#{$cdn-url}/charge/bg.png') no-repeat;
    background-size: 100% 100%;
    z-index: 120;
    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 15px;
      height: 15px;
    }
    p {
      // background: #000000;
      font-size: 12px;
      line-height: 16px;
      > b {
        font-size: 16px;
        line-height: 18px;
        font-weight: 700;
      }
      span {
        color: #ff452e;
      }
    }
    .btnGroup {
      display: flex;
      justify-content: center;
      margin: auto {
        top: 20px;
      };
      > button {
        width: 155px;
        height: 30px;
        border-radius:40px;
        font-size: 15px;
        color: #ffffff;
        background: #ff452e;
        border: none;
        outline: none;
      }
    }
}
</style>
